import type { DiagnosticSummary } from '@/diagnostic/domain/DiagnosticSummary.ts';
import {
  IpponBadge,
  IpponButtonCard,
  IpponHSpace,
  IpponIcon,
  IpponText,
  IpponVSpace,
  IpponVSpaceSlot,
} from '@ippon-ui/react';
import { useTranslation } from 'react-i18next';
import type { DiagnosticId } from '@/diagnostic/domain/DiagnosticId.ts';

export const HistorySummaryComponent = ({
  summary,
  onOpen,
}: {
  summary: DiagnosticSummary;
  onOpen: (id: DiagnosticId) => void;
}) => {
  const { t } = useTranslation('diagnostic');
  return (
    <IpponButtonCard
      border
      fullWidth
      onClick={() => onOpen(summary.id)}
      dataSelector="diagnostic.history.summary"
    >
      <IpponVSpace align="left" gap={16}>
        <IpponVSpaceSlot align="justify">
          <IpponHSpace gap={8} align={['space-between', 'middle']} wrap={true}>
            <IpponHSpace gap={8} align="middle" wrap={true}>
              <IpponText
                tag="h4"
                variant="body"
                size="large"
                dataSelector="diagnostic.history.summary.name"
              >
                {summary.name
                  .map((name) => name.value)
                  .orElse(t('diagnostic.history.summary.untitled'))}
              </IpponText>
              {!summary.linkedToOrganization && (
                <IpponBadge dataSelector="diagnostic.history.summary.personal" color="neutral">
                  {t('diagnostic.history.summary.personal')}
                </IpponBadge>
              )}
            </IpponHSpace>
            <IpponHSpace gap={4} align="middle">
              <IpponIcon name="calendar" variant="outline" color="neutral-tertiary" size={16} />
              <IpponText
                variant="body"
                dataSelector="diagnostic.history.summary.date"
                color="neutral-tertiary"
              >
                {summary.date.human}
              </IpponText>
            </IpponHSpace>
          </IpponHSpace>
        </IpponVSpaceSlot>
        <IpponHSpace gap={16} align="middle" wrap={true}>
          <IpponText
            variant="body"
            size="large"
            color="neutral-tertiary"
            dataSelector="diagnostic.history.summary.cost"
          >
            {summary.cost.human}
          </IpponText>
          <IpponText
            variant="body"
            size="large"
            color="neutral-tertiary"
            dataSelector="diagnostic.history.summary.duration"
          >
            {summary.duration.human}
          </IpponText>
        </IpponHSpace>
      </IpponVSpace>
    </IpponButtonCard>
  );
};
